import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    align-items: center;
    background: ${({ theme }) => theme.primaryBackgroundColor};
    color: ${({ theme }) => theme.text};
    margin: 0;
    padding: 0;
    font-family: ${({ theme }) => theme.primaryFont};
    transition: all 0.25s linear;
  }`;
